
<template>
  <div class="preview position-relative">
    <div class="">
      <div class="d-flex m-auto" style="gap:16px; width:741px;">
        <div class="preview-area border border-1 border-dark" :style="getCanvasSize">
          <img class="w-100 h-100" style="object-fit: scale-down;" v-if="(!isUploadDesign && !isUploadCutline)" :src="getUploadImage">
          <Preview3dPlate v-if="(isUploadDesign || isUploadCutline) && previewMode == 0" style=""></Preview3dPlate>
          <Preview2d v-if="(isUploadDesign || isUploadCutline) && previewMode == 2"></Preview2d>
        </div>
        <div class="control-area d-flex flex-column justify-content-center" :style="getControlAreaHeight">
          <div class="fw-bold"><p>{{ getTitleText }}</p></div>
          <div class="w-100 h-100 d-flex flex-column-reverse" :class="{'disable-ui disable-click':!isUploadDesign}">
            <button class="preview-btn" @click="clickPreview">
              プレビュー
            </button>
            <button class="preview-btn" @click="resetCamera">
              元の位置に戻す
            </button>
            <div class="preview-border d-flex flex-column" style="border-radius: 0px 0px 4px 4px;">
              <div class="">
                <div class="col d-flex justify-content-between mx-5 my-2">
                  <input class="me-2 radio-btn" type="radio" id="option1" value="0" v-model="previewMode" />
                  <label class="d-block" for="option1">3Dプレビュー</label>
                </div>
                <div class="col d-flex justify-content-between mx-5 my-2">
                  <input class="me-2 radio-btn" type="radio" id="option3" value="2" v-model="previewMode" />
                  <label for="option3">2Dプレビュー</label>
                </div>
              </div>

              <hr class="my-0">

              <div class="row m-0">
                <div class="col pl-3 mb-1 pt-1">
                  <div class="fw-bold text-start" style="font-size: 13px;">カットライン</div>
                  <div class="d-flex pt-1">
                    <div
                      class="color_box"
                      v-for="(color, index) in this.getColorList"
                      v-bind:key="index"
                      :style="getCutlineBoxStyle(index)"
                      @click="clickCutlineBox(index)"
                    />
                  </div>
                </div>
                <div class="col pl-3 mb-1 pt-1">
                  <div class="fw-bold text-start" style="font-size: 13px;">背景</div>
                  <div class="d-flex pt-1">
                    <div
                      class="color_box"
                      v-for="(color, index) in this.getColorList"
                      v-bind:key="index"
                      :style="getBackgroundBoxStyle(index)"
                      @click="clickBackgroundBox(index)"
                    />
                  </div>
                </div>
              </div>
              <div class="status-error-color text-start m-2" style="font-size: 13px;">
                ※ 確認用のため仕上がりカラーには影響しません
              </div>
            </div>
            <div class="preview-border" style="border-radius: 4px 4px 0px 0px;">
              <p class="preview-title m-0">プレートプレビュー</p>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column mt-4 mx-auto" style="width:741px;">
        <div class="caution-title">注意事項</div>
        <div class="caution-text text-start py-2 px-3">
          <p class="m-0">・カットラインとデザインが交わっている箇所はプリントが剥がれやすくなります。</p>
          <p class="m-0">・プレビューによるデザインとカットラインを元に制作致します。</p>
          <p class="m-0">・アタッチメントのつけ忘れ、5mm以下の小さなパーツは再現性の低下や破損に繋がります。また保証対象外となりますのでご注意ください。</p>
        </div>
      </div>
    </div>

    <!-- チュートリアル用1 -->
    <div class="tutorial-modal p-4" style="height:242px; top:60px;" :style="getTop(120)"
    v-if="this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 1">
      <p class="text-start fw-bold">デザイン入稿（PNG）</p>
      <p class="text-start">作成されたPNGデータをアップロードします</p>
      <p class="text-start m-0">アップロードするとキャンバスにプレビュー表示されます。</p>
      <p class="text-start">プレビューでズレが発生する場合サイズが間違っている可能性がありますのでデータを確認ください。</p>
      <button class="acry-btn position-absolute" style="width:105px; height:40px; border-radius: 40px; rihgt:10px; right: 18px;"
      @click="tutorialNextStep()">
        OK
      </button>
      <!-- 吹き出し -->
      <div class="position-absolute" style="right:-15px; top:40px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
        <path d="M33.1075 15.0974C33.8669 15.4596 33.8669 16.5404 33.1075 16.9026L1.93048 31.7722C1.26683 32.0888 0.499998 31.6049 0.499999 30.8696L0.5 1.13037C0.5 0.395104 1.26683 -0.0887492 1.93048 0.227774L33.1075 15.0974Z" fill="white"/>
        </svg>
      </div>
    </div>

    <!-- チュートリアル用2 -->
    <div class="tutorial-modal p-4" style="height:242px;" :style="getTop(210)"
    v-if="this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 2">
      <p class="text-start fw-bold">カットライン入稿（SVG）</p>
      <p class="text-start">作成されたSVGデータをアップロードします</p>
      <p class="text-start m-0">アップロードするとキャンバスにプレビュー表示されます。</p>
      <p class="text-start">パス情報をカットラインとして作成されますのでPNGデータと位置が合っているかご確認ください。</p>
      <button class="acry-btn position-absolute" style="width:105px; height:40px; border-radius: 40px; rihgt:10px; right: 18px;"
      @click="tutorialNextStep()">
        OK
      </button>
      <!-- 吹き出し -->
      <div class="position-absolute" style="right:-15px; top:40px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
        <path d="M33.1075 15.0974C33.8669 15.4596 33.8669 16.5404 33.1075 16.9026L1.93048 31.7722C1.26683 32.0888 0.499998 31.6049 0.499999 30.8696L0.5 1.13037C0.5 0.395104 1.26683 -0.0887492 1.93048 0.227774L33.1075 15.0974Z" fill="white"/>
        </svg>
      </div>
    </div>
  </div>

</template>

<script>
import {
  ProductId,
  PreviewColorList,
  GetCanvasSize,
  RightViewState
} from "@/js/Const.js";
import { CreateImageElement } from "@/js/CommonFunc.js";
import { OffScreen } from "@/js/OffScreen.js";
import Preview2d from "@/components/acyrpro/CommonView/CenterViewPreview2d_Ap.vue";
import Preview3dPlate from "@/components/acyrpro/CommonView/CenterViewPreview3dPlate_Ap.vue";
// import PreviewFloatMenu from "@/components/acyrpro/PreviewFloatMenu_Ap.vue";

export default {
  name: "CenterViewCommonPreview_Ap",
  props: {},
  data: function () {
    return {
      selectProductData: null,
      previewMode: 0,
    };
  },
  created() {
    // チュートリアル開始
    // this.$store.commit("showPreviewTutorial");
  },
  watch: {
    "$store.state.commonPreviewData.selectCutlineColor": async function () {
      let canvasSize = GetCanvasSize(this.$store.state.commonPreviewData.selectProductId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image = await CreateImageElement(this.$store.state.commonPreviewData.frameCutlineImageURL);
      offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      offScreen.replacement(PreviewColorList[this.$store.state.commonPreviewData.selectCutlineColor]);

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      this.$store.commit("setCommonFrameCutlineImageURL", URL.createObjectURL(blob));
    },
  },
  computed: {
    isUploadDesign() {
      return this.$store.state.commonPreviewData.designImageURL != null;
    },
    isUploadCutline() {
      return this.$store.state.commonPreviewData.frameCutlineImageURL != null;
    },
    getTitleText() {
      if( this.$store.state.rightViewState == RightViewState.SamplePreview ){
        switch (this.$store.state.selectProductId) {
          case ProductId.S:
          case ProductId.S_SVG:
          case ProductId.S_SHARE:
          case ProductId.S_SVG_SAMPLE:
          case ProductId.S_SHARE_SAMPLE:
            return "Sサイズ (サンプル注文)";
          case ProductId.M:
          case ProductId.M_SVG:
          case ProductId.M_SHARE:
          case ProductId.M_SVG_SAMPLE:
          case ProductId.M_SHARE_SAMPLE:
            return "Mサイズ (サンプル注文)";
          case ProductId.L:
          case ProductId.L_SVG:
          case ProductId.L_SHARE:
          case ProductId.L_SVG_SAMPLE:
          case ProductId.L_SHARE_SAMPLE:
            return "Lサイズ (サンプル注文)";
          default:
            return "";
        }
      }else{
        switch (this.$store.state.commonPreviewData.selectProductId) {
          case ProductId.S:
          case ProductId.S_SVG:
          case ProductId.S_SHARE:
            return "Sサイズ (簡易編集)";
          case ProductId.M:
          case ProductId.M_SVG:
          case ProductId.M_SHARE:
            return "Mサイズ (簡易編集)";
          case ProductId.L:
          case ProductId.L_SVG:
          case ProductId.L_SHARE:
            return "Lサイズ (簡易編集)";
          default:
            return "";
        }
      }
    },
    getColorList() {
      return PreviewColorList;
    },
    getBackgroundBoxStyle() {
      return function (index) {
        return {
          border:
            this.$store.state.commonPreviewData.selectBackgroundColor == index ? "solid 2px" : "solid 1px",
          "border-color":
            this.$store.state.commonPreviewData.selectBackgroundColor == index ? "#000000" : "#999999",
          "background-color": PreviewColorList[index],
        };
      };
    },
    getCutlineBoxStyle() {
      return function (index) {
        return {
          border:
            this.$store.state.commonPreviewData.selectCutlineColor == index ? "solid 2px" : "solid 1px",
          "border-color":
            this.$store.state.commonPreviewData.selectCutlineColor == index ? "#000000" : "#999999",
          "background-color": PreviewColorList[index],
        };
      };
    },
    getCanvasSize(){
      let canvasSize = GetCanvasSize(this.$store.state.commonPreviewData.selectProductId);
      return {
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
    getControlAreaHeight(){
      let canvasSize = GetCanvasSize(this.$store.state.commonPreviewData.selectProductId);
      return {
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
    getUploadImage(){
      switch(this.$store.state.commonPreviewData.selectProductId){
          case ProductId.S:
          case ProductId.S_SVG:
          case ProductId.S_SHARE:
          case ProductId.S_SVG_SAMPLE:
          case ProductId.S_SHARE_SAMPLE:
            return require("@/assets/acrypro/upload_info_s.svg");
          case ProductId.M:
          case ProductId.M_SVG:
          case ProductId.M_SHARE:
          case ProductId.M_SVG_SAMPLE:
          case ProductId.M_SHARE_SAMPLE:
            return require("@/assets/acrypro/upload_info_m.svg");
          case ProductId.L:
          case ProductId.L_SVG:
          case ProductId.L_SHARE:
          case ProductId.L_SVG_SAMPLE:
          case ProductId.L_SHARE_SAMPLE:
            return require("@/assets/acrypro/upload_info_l.svg");
          default:
            return require("@/assets/acrypro/upload_info_s.svg");
      }
    },
  },
  components: {
    Preview2d,
    Preview3dPlate,
  },
  methods: {
    clickBackgroundBox(index) {
      this.$store.commit("setCommonSelectBackgroundColor", index);
    },
    clickCutlineBox(index) {
      this.$store.commit("setCommonSelectCutlineColor", index);
    },
    changeMode(newMode) {
      this.previewMode = newMode;
    },
    async clickPreview(){
      let canvasSize = GetCanvasSize(this.$store.state.commonPreviewData.selectProductId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      if( this.$store.state.commonPreviewData.designImageURL ){
        let image = await CreateImageElement(this.$store.state.commonPreviewData.designImageURL);
        offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      }

      if( this.$store.state.commonPreviewData.frameCutlineImageURL ){
        let image = await CreateImageElement(this.$store.state.commonPreviewData.frameCutlineImageURL);
        offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      }

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });
      this.$store.commit("showImagePreview", URL.createObjectURL(blob));
    },
    resetCamera(){
      if( this.$store.state.resetCameraFunc ) this.$store.state.resetCameraFunc();
    },
    tutorialNextStep(){
      if( this.$store.state.tutorial.isFirst ){
        // 初回は強制で全て表示
        if(this.$store.state.tutorial.previewStep == 2){
          this.$store.commit("hidePreviewTutorial");
          this.$store.commit("setIsFirstTutorial", false);
        }else{
          this.$store.commit("previewTutorialNextStep");
        }
      }else{
        // 2回目以降は一部分のみ表示
          this.$store.commit("hidePreviewTutorial");
      }
    },
    getTop(top) {
      return {
        'top': `${top - this.$store.state.tutorial.previewTutorialScroll}px`,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview{
  // max-width: 805px;
  width: 100%;
  padding: 16px 32px;

}

.control-area{
  // margin-left: 16px;
  width: 243px;
}

.preview-btn{
  height: 40px;
  margin-top: 8px;
  font-weight: bold;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 4px;
  background-color: $background-white-color;
}

.preview-border{
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
}

.preview-title{
  color: $text-white-color;
  background-color: $primary-main-color;
}

.color_box {
  height: 25px;
  width: 25px;
  margin: 2px;
  border-radius: 5px;
}

.radio-btn{
  height: 25px;
  width: 25px;
  accent-color: #8593bc;
}

.caution-title {
  font-weight: bold;
  color: $text-white-color;
  background-color: $status-error-color;
  border: solid 1px $status-error-color;
  border-radius: 5px 5px 0px 0px;
}

.caution-text {
  font-size: 12px;
  font-weight: bold;
  color: $status-error-color;
  background-color: $background-white-color;
  border: solid 1px $status-error-color;
  border-radius: 0px 0px 5px 5px;
}

.disable-ui {
  opacity: 0.5;
}

.disable-click {
  pointer-events: none;
}

.tutorial-modal{
  width: 850px;
  position: absolute;
  right: 0px;
  z-index: 3;
  background: white;
  border-radius: 4px;
}
</style>
